interface LoaderProps {
  size?: number;
  height?: number;
  gap?: number;
  color?: string;
  align?: 'center' | 'left' | 'right';
  inline?: boolean;
}
export default function Loader(props: LoaderProps) {
  const { size = 8, height = 32, gap = 6, color = '#d1d5db', align = 'center', inline = false } = props;

  const Dot = (
    <div
      className="es-loader-square"
      style={{
        width: size,
        height: size,
        backgroundColor: color,
      }}
    ></div>
  );

  return (
    <div
      className="es-loader"
      style={{
        gap: `${gap}px`,
        height: `${height}px`,
        justifyContent: align === 'center' ? 'center' : align === 'left' ? 'flex-start' : 'flex-end',
        display: inline ? 'inline-flex' : 'flex',
      }}
    >
      {Dot}
      {Dot}
      {Dot}
    </div>
  );
}
